import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function HashScrollManager() {
  const location = useLocation();

  useEffect(() => {
    const frameId = window.requestAnimationFrame(() => {
      const hash = location.hash.slice(1);

      if (!hash) {
        window.scrollTo({ top: 0, behavior: "auto" });
        return;
      }

      const target = document.getElementById(decodeURIComponent(hash));

      if (target) {
        target.scrollIntoView({ block: "start", behavior: "auto" });
        return;
      }

      window.scrollTo({ top: 0, behavior: "auto" });
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [location.hash, location.pathname]);

  return null;
}
